// Components==============
import { faExchange, faPlus } from '@fortawesome/pro-regular-svg-icons';
import AddActivityModal from 'components/UI/AddActivityModal/AddActivityModal';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import './AddSwitchModalButton.module.scss';
// =========================

export type AddSwitchButtonProps = {
  permission?: ProcessType;
  fn: 'switch' | 'add';
};

export default function AddSwitchButton({
  permission,
  fn,
}: AddSwitchButtonProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <CircleButton
        icon={fn === 'switch' ? faExchange : faPlus}
        color="white-blue-shadow"
        onClick={() => setModalIsOpen(true)}
      />
      <AnimatePresence>
        {modalIsOpen && (
          <AddActivityModal
            permission={permission}
            fn={fn}
            setModalIsOpen={setModalIsOpen}
            origin="project"
          />
        )}
      </AnimatePresence>
    </>
  );
}
